import { PurchaseIntentAggregator } from "../purchase-intent";
import { IOutputRecord, TargetConceptKey } from "../types";

type TemporaryAggretionTarget = "brandUser" | "brandNoneUser" | "categoryNoneUser" | "categoryUser";

/**
 * 購入意向の計算処理
 */
export class PurchaseIntentConceptByDemandForecast {
	constructor(protected concept: TargetConceptKey) {}
	protected brandUser = new PurchaseIntentAggregator();
	protected brandNoneUser = new PurchaseIntentAggregator();
	protected categoryNoneUser = new PurchaseIntentAggregator();
	protected categoryUser = new PurchaseIntentAggregator();
	protected countUpTarget(target: TemporaryAggretionTarget, purchaseIntent: number, weight: number) {
		this[target].countUp(purchaseIntent, weight);
	}
	public countUp(record: IOutputRecord) {
		// 対象のコンセプトではない場合はカウントアップしない
		if (!record.answerConceptAndTargetDemandForecast(this.concept)) return;
		const weight = record.getWeightDemandForecast(this.concept);
		const purchaseIntent = record.getPurchaseIntent();
		if (!record.isCategoryUser()) {
			this.countUpTarget("categoryNoneUser", purchaseIntent, weight);
			return;
		}
		this.countUpTarget("categoryUser", purchaseIntent, weight);
		this.countUpTarget(record.isBrandUser() ? "brandUser" : "brandNoneUser", purchaseIntent, weight);
	}
	public getResult() {
		return {
			brandUser: this.brandUser.getResult(),
			brandNoneUser: this.brandNoneUser.getResult(),
			categoryNoneUser: this.categoryNoneUser.getResult(),
			categoryUser: this.categoryUser.getResult(),
		};
	}
}
